import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import store from './store';
import actions from './actions';

export default class ErrorMessages extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.store = store;
  }
  componentDidMount() { }
  componentWillUpdate() { }
  getErrors() {
    let errors = this.state.errors.map( (error,index) => {
      let errorKey='error-'+index;
        return ( <li key={errorKey}>{error}</li> )
    });
    return errors;
  }
  render() {
    if(this.state.errors.length==0) {
      return false;
    }
    let errors = this.getErrors();
    return (
      <ul className="error-messages">
        {errors}
      </ul>
    )
  } // render
}
ErrorMessages.propTypes= { };
ErrorMessages.defaultProps= { };



// WEBPACK FOOTER //
// ./medscape_modules/qna/error-messages/app.jsx